// extracted by mini-css-extract-plugin
export var actionButton = "_ko-0";
export var fileInput = "_ko-2";
export var paperclip = "_ko-1";